import {
  GET_STYLE_WISE_STOCK_REPORT_REQUEST,
  GET_STYLE_WISE_STOCK_REPORT_SUCCESS,
  GET_STYLE_WISE_STOCK_REPORT_ERROR,
  } from "../actions/types";
  
  export const styleWiseStockReport = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case   GET_STYLE_WISE_STOCK_REPORT_REQUEST:
        return {
          loading: true,
        };
      case   GET_STYLE_WISE_STOCK_REPORT_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case   GET_STYLE_WISE_STOCK_REPORT_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  